import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { Responsibility } from "../../features/responsibilities/responsibility.model";

@Component({
  selector: "app-responsibilities-table",
  templateUrl: "./responsibilities-table.component.html",
  styleUrls: ["./responsibilities-table.component.css"],
})
export class ResponsibilitiesTableComponent implements AfterViewInit {
  displayedColumns: string[] = ["name", "officeFantasyName", "actions"];
  dataSource = new MatTableDataSource<Responsibility>();

  @Input() set responsibilities(value: Responsibility[] | null | undefined) {
    this.dataSource.data = value ?? [];
  }

  @Output() edit = new EventEmitter<Responsibility>();

  @Output() delete = new EventEmitter<Responsibility>();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onEdit(row: Responsibility): void {
    this.edit.emit(row);
  }

  onDelete(row: Responsibility): void {
    this.delete.emit(row);
  }
}
